import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp('^https?://docs.google.com/document/(.*)$');
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  return (
    <Portal url={url} title="Google Docs" {...rest} fullHeight withMetadata />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],

  name: 'google-docs-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: false,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Google Docs',
    description: 'Embed a Google Docs document.',
    searchTerms: ['embed', 'google', 'docs'],
    icon: 'tabler:google-docs',
  },
});
